<template>
  <div class="progress-circle">
    <svg :width="size" :height="size" viewBox="0 0 32 32">
      <circle
        r="13"
        cx="16"
        cy="16"
        fill="transparent"
        class="progress-background"
      ></circle>
      <circle
        r="13"
        cx="16"
        cy="16"
        fill="transparent"
        class="progress-bar"
        :stroke-dasharray="dashArray"
        :stroke-dashoffset="dashOffset"
      ></circle>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 8,
    },
    percent: {
      type: Number,
      default: 0.1,
    },
  },
  data() {
    return {
      dashArray: Math.PI * 2 * 13,
    };
  },
  computed: {
    dashOffset() {
      return (1 - this.percent / 100) * this.dashArray;
    },
  },
};
</script>

<style lang="less" scoped>
.progress-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  circle {
    stroke-width: 6px;
    transform-origin: center;
  }
  .progress-background {
    stroke: #dadde0;
  }
  .progress-bar {
    stroke: #32b846;
    transform: rotate(-90deg);
  }
}
</style>
